import { Injectable } from '@angular/core';

export class OneTimer {
    private timerId: ReturnType<typeof setTimeout> | null = null;

    constructor(private readonly milliseconds: number) {}

    public start(action: () => void): void {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }

        this.timerId = setTimeout(() => {
            action();
            this.timerId = null;
        }, this.milliseconds);
    }

    public stop(): void {
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class OneTimerService {
    public createTimer(milliseconds: number): OneTimer {
        return new OneTimer(milliseconds);
    }
}
